import { selectors } from '@store';
import { buildLinkedTextId } from 'src/helpers/text-overflow-links';
import observeStore from '../observeStore';
import { TextOverflowChainHandler } from 'assets/js/editor/factory/text-overflow/chainHandler';

function onLinkedTextElementsUpdated (linkedTextElements, state) {
  const { editor: { activePage } } = state;
  const flatLinkedTextElements = selectors.editor.getFlatLinkedTextElements(state);

  const svgContent = document.getElementById('svgcontent');
  const textMock = document.getElementById('textmock');
  const chainHandler = new TextOverflowChainHandler();

  const relatedTextLinks = textMock ? new Set(chainHandler.getLinkedTextElementsFromPage(activePage)) : new Set();

  const removeParentChildData = (svg) => {
    [...svg.querySelectorAll('.textarea')].forEach(element => {
      delete element.dataset.parent;
      delete element.dataset.child;
    });
  };

  svgContent && removeParentChildData(svgContent);
  textMock && removeParentChildData(textMock);

  for (const { pageId, id: elementId, prevId, nextId } of flatLinkedTextElements) {
    const isCurrentPage = String(pageId) === String(activePage);
    let element = isCurrentPage
      ? svgContent?.querySelector(`#${elementId}[data-page-id="${pageId}"]`) || svgContent?.querySelector(`#${elementId}`)
      : textMock?.querySelector(`#${elementId}[data-page-id="${pageId}"]`);

    if (!element && !isCurrentPage) {
      const elementData = chainHandler.getElementDataFromStore(elementId, pageId);
      if (!elementData?.nodeString) continue;

      textMock.insertAdjacentHTML('beforeend', elementData.nodeString);

      element = textMock.lastChild;

      element.dataset.pageId = pageId;
    }

    if (!element) continue;

    let hasChange = relatedTextLinks.has(buildLinkedTextId(pageId, elementId));

    if (prevId) {
      const newParentId = buildLinkedTextId(prevId.pageId, prevId.id);
      hasChange = hasChange || element.dataset.parent !== newParentId;

      element.dataset.parent = newParentId;
    } else {
      hasChange = hasChange || !!element.dataset.parent;
      element.removeAttribute('data-parent');
    }

    if (nextId) {
      const newChildId = buildLinkedTextId(nextId.pageId, nextId.id);
      hasChange = hasChange || element.dataset.child !== newChildId;
      element.dataset.child = newChildId;
    } else {
      hasChange = hasChange || !!element.dataset.child;
      element.removeAttribute('data-child');
    }

    if (!hasChange) {
      element.remove();
    }
  }
}

const onTextOverflowLockedUpdated = (locked) => {
  const textOverflowContextMenu = document.querySelector('.context-menu-text-overflow');
  if (textOverflowContextMenu) {
    textOverflowContextMenu.classList.toggle('disabled', locked);
  }
};

export function configureObserver (store) {
  observeStore(
    store,
    (state) => state.editor.linkedTextElements,
    onLinkedTextElementsUpdated
  );
  observeStore(
    store,
    (state) => state.navigation.textOverflow.locked,
    onTextOverflowLockedUpdated
  );
}
